
import { Rabbit } from "lucide-react";
import { SocialIcons } from "../SocialIcons";
import { Link } from "react-router-dom";
import { ROUTES } from "@/constants/app";
import { Separator } from "@/components/ui/separator";

export const Footer = () => {
  return (
    <footer className="w-full bg-white/80 backdrop-blur-sm">
      <Separator />
      <div className="container px-4 sm:px-6 lg:px-8 w-full max-w-7xl mx-auto py-6">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 w-full mb-8">
          <div className="space-y-4 flex-1">
            <h3 className="font-medium text-sm text-gray-700">À propos</h3>
            <div className="text-sm text-gray-600 max-w-md space-y-2">
              <p className="font-medium">NLocale : Où chaque coin cache une surprise !</p>
              <p>Visiteurs : Vivez l'extraordinaire</p>
              <p>Locaux : Simplifiez vos sorties</p>
              <p>Pros : Boostez votre biz</p>
            </div>
          </div>
          <div className="space-y-4">
            <h3 className="font-medium text-sm text-gray-700">Suivez-nous</h3>
            <SocialIcons iconClassName="w-5 h-5" className="flex-wrap" />
          </div>
        </div>
        
        <Separator className="my-6" />
        
        <div className="flex flex-col-reverse md:flex-row md:items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-xs text-gray-600">
            <p className="whitespace-nowrap">
              © 2025 NLocale
            </p>
            <span className="hidden sm:inline-block">•</span>
            <p className="flex items-center gap-1 text-center">
              Fièrement conçu à Laon
              <Rabbit className="w-3 h-3 inline-block" />
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center sm:justify-end gap-4 text-xs">
            <Link 
              to={ROUTES.LEGAL}
              className="text-gray-600 hover:underline whitespace-nowrap"
            >
              Mentions légales
            </Link>
            <Link 
              to={ROUTES.PRIVACY}
              className="text-gray-600 hover:underline whitespace-nowrap"
            >
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
